const localeMap = {
  GBP: 'en-GB',
  NGN: 'en-NG',
  USD: 'en-US',
  EUR: 'de-DE',
  CAD: 'en-CA',
  ZAR: 'en-ZA',
};

export const DEFAULT_CURRENCY = 'GBP';

export function formatCurrency(value, currencyCode = DEFAULT_CURRENCY) {
  const safeValue = Number(value) || 0;
  const locale = localeMap[currencyCode] || 'en-GB';
  const formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(safeValue);
  return formatted.replace(/\u00A0|\u202F/g, ' ');
}

export const SUPPORTED_CURRENCIES = [
  { code: 'GBP', label: 'British Pound (GBP)' },
  { code: 'NGN', label: 'Nigerian Naira (NGN)' },
  { code: 'USD', label: 'US Dollar (USD)' },
  { code: 'EUR', label: 'Euro (EUR)' },
  { code: 'CAD', label: 'Canadian Dollar (CAD)' },
  { code: 'ZAR', label: 'South African Rand (ZAR)' },
];
